import { render, staticRenderFns } from "./DeliveryInformation.vue?vue&type=template&id=4b50965f&scoped=true&"
import script from "./DeliveryInformation.vue?vue&type=script&lang=ts&"
export * from "./DeliveryInformation.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryInformation.vue?vue&type=style&index=0&id=4b50965f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b50965f",
  null
  
)

export default component.exports